import { Icon, IconButton, List, ListItem, ListItemText, Switch } from '@material-ui/core';
import React from 'react';
import DiseaseFunctions from '../../../../store/masterData/disease/functions';
import ToggleButton from '../../../customComponents/button/ToggleButton';
import ScoutingDiseaseMultiselect from '../../../customComponents/dropdowns/scouting/DiseaseMultiselect';

interface IScoutingDiseaseSelectorProps {
    sections ?: Array<string>;
    components ?: Array<string>;
    diseases ?: Array<string>;
    onDiseasesChange ?: (diseases ?: Array<string> | null) => void;
}

interface IScoutingDiseaseSelectorState {
    edit : boolean;
    toggle : boolean;
}

class ScoutingDiseaseSelector extends React.PureComponent<IScoutingDiseaseSelectorProps, IScoutingDiseaseSelectorState> {
    constructor(props : IScoutingDiseaseSelectorProps) {
        super(props);
        this.state = {
            edit: true,
            toggle: false,
        };
    }

    public componentDidMount = () => {
        this.loadData();
    };

    public loadData = async () => {
        DiseaseFunctions.getList();
    };

    private readonly onClose = () => {
        if (!this.props.diseases?.length) return;
        this.setState({
            edit: false,
        });
    };

    private readonly onEditClick = () => {
        this.setState({
            edit: !this.state.edit,
        });
    };

    private readonly onToggleClick = () => {
        this.setState({
            toggle: !this.state.toggle,
            edit: !this.state.toggle,
        });

        if (!this.props.onDiseasesChange) return;

        this.props.onDiseasesChange([]);
    };

    public render = () => {
        const { sections, diseases, components, onDiseasesChange } = this.props;
        const { edit, toggle } = this.state;
        return (
            <>
                <List className='mt15' disablePadding dense>
                    <ListItem className={'bcig cw'} key={'SPECIFIC - Disease'}>
                        <ListItemText primary={'SPECIFIC - Disease'} title={'SPECIFIC - Disease'} />
                        {
                            toggle &&
                            !edit &&
                            <IconButton onClick={this.onEditClick} color='secondary' size='small'>
                                <Icon>edit</Icon>
                            </IconButton>
                        }
                        <Switch
                            id='toggle'
                            size='small'
                            checked={toggle}
                            onClick={this.onToggleClick}
                            color='primary'
                            disabled={!components?.length}
                        />
                    </ListItem>
                </List>
                {
                    toggle &&
                    !edit &&
                    diseases &&
                    <div className='fdc aic p10'>
                        <div className='fdr jcsb fww'>
                            {
                                diseases.map((n, i) => (
                                    <ToggleButton
                                        key={n}
                                        className={`mt15 ${i !== (diseases.length - 1) ? 'mr15' : ''}`}
                                        value={`${n}`}
                                        selected
                                        disabled
                                    >
                                        {`${n}`.toLocaleUpperCase()}
                                    </ToggleButton>
                                ))
                            }
                        </div>
                    </div>
                }
                {
                    toggle &&
                    edit &&
                    <div className='fdc aifs p10'>
                        <ScoutingDiseaseMultiselect
                            value={diseases ?? []}
                            onChange={onDiseasesChange}
                            fullWidth
                            sections={sections}
                            components={components}
                            onClose={this.onClose}
                        />
                    </div>
                }
            </>
        );
    };
}

export default ScoutingDiseaseSelector;
